import { Box, Button, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import {
  getAreaDrugReport,
  getAreaPatientDrugReport,
  getAreaReport,
  getGroupsTrips,
} from "../../api/admins";
import { getAllGroups, getMyTrips } from "../../api/group";
import { Loader } from "../loader";
import CustomizedHook from "../project/autocomplatePro";

export default function ReportFilter({ group, typeId }) {
  const [groupData, setGroupData] = useState();
  const [tripsData, setTripsData] = useState();
  const [areasData, setAreasData] = useState();
  const [areaId, setAreaId] = useState();
  const [loading, setLoading] = useState(false);

  const mapToNameAndId = (array) => {
    return array.map((item) => ({
      id: item.id,
      name: item.name,
    }));
  };

  const md = useMediaQuery("(max-width:450px)");

  useEffect(() => {
    if (group) {
      getMyTrips("?pageIndex=0&pageSize=100")
        .then((x) => {
          setTripsData(x.content);
        })
        .catch(() => {});
    } else if (!group) {
      getAllGroups()
        .then((x) => setGroupData(mapToNameAndId(x.content)))
        .catch((z) => {});
    }
  }, []);

  return (
    <>
      <Box
        display="flex"
        flexDirection={md ? "column" : "row"}
        gap={"10px"}
        width={"100%"}
      >
        {!group && (
          <CustomizedHook
            maxWidth={md ? "100%" : "calc(26vw - 20px)"}
            parentWidth={md ? "100%" : "unset"}
            width={"100%"}
            placeholder={"انتخاب کنید."}
            label="نام گروه"
            options={groupData}
            onChange={(_, newValue) => {
              getGroupsTrips(newValue.id)
                .then((x) => {
                  setTripsData(x);
                })
                .catch(() => {});
            }}
          />
        )}
        <CustomizedHook
          maxWidth={md ? "100%" : "calc(26vw - 20px)"}
          width={"100%"}
          parentWidth={md ? "100%" : "unset"}
          placeholder={"انتخاب کنید."}
          label="نام اردو"
          options={tripsData}
          onChange={(_, newValue) => {
            setAreasData(newValue.areas);
          }}
        />
        <CustomizedHook
          maxWidth={md ? "100%" : "calc(26vw - 20px)"}
          width={"100%"}
          parentWidth={md ? "100%" : "unset"}
          placeholder={"انتخاب کنید."}
          label="نام منطقه"
          options={areasData}
          onChange={(_, newValue) => {
            setAreaId(newValue);
          }}
        />
      </Box>
      <Button
        variant="contained"
        color="primary"
        disabled={loading}
        style={{
          width: "150px",
          cursor: areaId?.id ? "pointer" : "not-allowed",
        }}
        onClick={() => {
          if (areaId?.id) {
            setLoading(true);
            if (typeId === "1") {
              getAreaReport(areaId?.id)
                .then((x) => {
                  const blob = new Blob([x], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `گزارشات کلی اردو ${areaId?.name}.xlsx`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);
                })
                .finally(() => setLoading(false));
            } else if (typeId === "2") {
              getAreaDrugReport(areaId?.id)
                .then((x) => {
                  const blob = new Blob([x], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `گزارشات عملکرد داروخانه ${areaId?.name}.xlsx`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);
                })
                .finally(() => setLoading(false));
            } else if (typeId === "3") {
              getAreaPatientDrugReport(areaId?.id)
                .then((x) => {
                  const blob = new Blob([x], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `گزارش جامع تجویز دارو به بیماران ${areaId?.name}.xlsx`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);
                })
                .finally(() => setLoading(false));
            }
          }
        }}
      >
        دریافت گزارش
      </Button>

      {loading && <Loader />}
    </>
  );
}
